import React, { Suspense, memo } from "react";
import "../styles/homepage.css";
import { Route, Routes } from "react-router-dom";

const News = React.lazy(() => import("../pages/News"));
const Movies = React.lazy(() => import("../pages/Movies"));
const Music = React.lazy(() => import("../pages/Music"));
const Sports = React.lazy(() => import("../pages/Sports"));
// const Entertainment = React.lazy(() => import("../pages/Entertainment"));
const Extra = React.lazy(() => import("../pages/Extra"));
const TvPlayer = React.lazy(() => import("../pages/TvPlayer"));

const Homepage = () => {
  return (
    <div className="content">
      <div className="homepage">
        <Suspense fallback={<div style={{ color: "#fff" }}>Loading...</div>}>
          <Routes>
            <Route path="/" element={<News />} />
            <Route path="/movies" element={<Movies />} />
            <Route path="/sports" element={<Sports />} />
            {/* <Route path="/entertainment" element={<Entertainment />} /> */}
            <Route path="/music" element={<Music />} />
            <Route path="/extra" element={<Extra />} />
            <Route path="/:type/:channelId" element={<TvPlayer />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  );
};

export default memo(Homepage);
